import { css, cva } from '@/styled-system/css';

export const TOAST_PROVIDER_ITEM_TRANSITION_DURATION_MS = 450;

export const toastProviderItemRecipe = cva({
  base: {
    display: 'grid',
    position: 'relative', // This creates a proper stacking context where the latest in the list is on top
    listStyleType: 'none',
    transitionProperty: {
      _motionReduce: 'none',
      _motionSafe: 'grid-template-rows, opacity',
    },
    transitionDuration: {
      _motionReduce: '0s',
      _motionSafe: '{durations.450}',
    },
    transitionTimingFunction: 'cubic-bezier(0.76, 0, 0.24, 1)',
  },
  variants: {
    animationState: {
      entering: {
        opacity: 0,
        gridTemplateRows: 'minmax(0, 0fr)',
      },
      open: {
        opacity: 1,
        gridTemplateRows: 'minmax(0, 1fr)',
      },
      exiting: {
        opacity: 0,
        gridTemplateRows: 'minmax(0, 0fr)',
      },
    },
  },
});

export const toastProviderItemStyles = css.raw({
  '& .c11n_toast__root': {
    pointerEvents: 'auto',
    // Margin is applied to the Toasts as opposed to 'gap' on the flex container
    // so that this gap is included in the animation to prevent jumpiness
    marginBlockEnd: 'layout.tight',
  },
});

export const toastProviderItemContentStyles = css.raw({
  minHeight: 0,
});
